import React from 'react'
import { Link } from 'react-router-dom'

import Image from '../Image/index'


const ProductItem = ({
    url,
     image, 
     title, 
     price
}) => {

    return (
        <div>
            <div className="product-1">
                <Link to={url}>
                    <div className="product-1-img">
                        <Image className="img-fluid img-100 transition" image={image} />
                            </div>
                    <div className="product-1-content">
                        <h5>Pots</h5>
                        <h3 className="h3-antwerp-semibold">
                            {title}</h3>
                        <h6 className="cube flip-to-top">
                            <div className="default-state">
                                <span>{price}</span>
                            </div>
                            <div className="active-state">
                                <span>View Details</span>
                            </div>
                        </h6>
                    </div>
                </Link>
            </div>
        </div>
    )
}



export default ProductItem